<app-tabla
  [totalCount]="totalCount"
  [datos]="activos"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [crear]="botonCrear"
  [filtros]="filtros"
  [showHijos]="true"
  [emptyState]="{ title: 'Todavía no hay colectivos' }"
></app-tabla>
